import { ECouponApplyOn } from '@common/enums/coupon.enum';
import { t } from '@common/hooks/use-t.hook';
import { ICoupon, ICouponItemConstraints } from '@src/api/item-generated-api';

export const getDiscountTitle = (coupon: ICoupon | undefined): string => {
    if (!coupon) {
        return '';
    }
    if (coupon.apply_on === ECouponApplyOn.invoice_amount) {
        return t('Coupon');
    } else {
        const itemConstraints = coupon.item_constraints?.reduce((itemsArr: string[], item: ICouponItemConstraints) => {
            if (item.constraint === 'all') {
                itemsArr.push(`${item.item_type as string}s`);
            } else if (item.constraint === 'specific') {
                itemsArr.push(`specific ${item.item_type as string}s`);
            }
            return itemsArr;
        }, []);

        return t(`Coupon${itemConstraints?.length ? ` (${itemConstraints.join(', ')})` : ''}:`);
    }
};
